import React, { useCallback, useMemo } from "react";
import TeamScores from "../TeamScores/TeamScores";
// import GameTimer from "../GameTimer/GameTimer";
import useSocketEvents from "../../../../../../hooks/useSocketEvents";
import { LIVE_CHAT_CONSTANTS } from "../../../../../../lib/constants/websocketConstants";
import { connect, useSelector } from "react-redux";
import { updateGameDetailsReducer } from "../../../../../../redux/slices/scorerSlice";
import { useLiveGameTimerContext } from "../../../../../../context/GameTimer";
import { getCurrentTimestamps } from "../../../../../../lib/utils/dateAndTimeFormatting";
import { convertSecondsToTime } from "../GameTimer/gameTimer.data";

const GameScoreAndTimer = ({ socket, updateGameDetailsReducer }) => {
  const { gameDetails } = useSelector(state => state.scorer);
  const { toggleTimer, updateTimer, isTimerPaused } = useLiveGameTimerContext(); // Timer Hook

  const handleUpdateGameTimerStatus = useCallback(({ isGameTimerOn, currentTimestamp }) => {
    // Update Timer
    if (isGameTimerOn !== undefined) {
      toggleTimer(!isGameTimerOn);
    }
    if (currentTimestamp !== undefined) {
      updateGameDetailsReducer({ currentTimestamp });
    }
  }, []);

  const handleChangeGameTimer = useCallback(({ lastGameTimer, lastGameTimerUpdatedAt, isTimeoutStarted, timeoutEndTime, currentTimestamp, displayLastGameTimer }) => {
    // Update Time
    if (lastGameTimer !== undefined) {
      const _timer = (lastGameTimer || lastGameTimer === 0)
        ? convertSecondsToTime(lastGameTimer)
        : ({ hours: 0, minutes: gameDetails?.matchPlayTime || 0, seconds: 0 })
      const _isPaused = isTimerPaused;

      const _pendingTime = getCurrentTimestamps() - gameDetails?.lastGameTimerUpdatedAt;

      const _finalTimer = _isPaused ? _timer : lastGameTimer > 0 ? convertSecondsToTime(lastGameTimer - (_pendingTime / 1000)) : { hours: 0, minutes: 0, seconds: 0 };

      // // Initialize Timer
      updateTimer(_finalTimer);
      updateGameDetailsReducer({ lastGameTimerUpdatedAt });
    }

    if (isTimeoutStarted !== undefined || timeoutEndTime !== undefined || displayLastGameTimer !== undefined) {      
      updateGameDetailsReducer({ isTimeoutStarted, timeoutEndTime, displayLastGameTimer })
    }
    if (currentTimestamp !== undefined) {
      updateGameDetailsReducer({ currentTimestamp });
    }
  }, []);

  const handleChangeGameSession = useCallback(({ currentSession, currentMatchQuater, currentTimestamp, upcomingMatchQuater, isGameEnded }) => {
    // Update Game Session
    updateGameDetailsReducer({ currentSession, currentMatchQuater });
    if (currentTimestamp !== undefined) {
      updateGameDetailsReducer({ currentTimestamp });
    }

    if (upcomingMatchQuater !== undefined) {
      updateGameDetailsReducer({ upcomingMatchQuater });
    }

    if (isGameEnded !== undefined) {
      updateGameDetailsReducer({ isGameEnded });
    }
  }, []);

  const handleUpdateBasketZone = useCallback(({ homeTeamDefensiveBasketZone, awayTeamDefensiveBasketZone , currentTimestamp }) => {
    if (homeTeamDefensiveBasketZone !== undefined || awayTeamDefensiveBasketZone  !== undefined) {
      updateGameDetailsReducer({ homeTeamDefensiveBasketZone, awayTeamDefensiveBasketZone  });
    }
    if (currentTimestamp !== undefined) {
      updateGameDetailsReducer({ currentTimestamp });
    }
  }, []);

  const handleCurrentStamp = useCallback((currentTimestamp) => {
    if (currentTimestamp !== undefined) {
      updateGameDetailsReducer({ currentTimestamp });
    }
  }, []);
  
  // Listen for socket-events
  useSocketEvents(socket,
    useMemo(() => ({
      [LIVE_CHAT_CONSTANTS.UPDATE_GAME_STATUS]: handleUpdateGameTimerStatus,
      [LIVE_CHAT_CONSTANTS.UPDATE_GAME_TIMER]: handleChangeGameTimer,
      [LIVE_CHAT_CONSTANTS.UPDATE_GAME_SESSION]: handleChangeGameSession,
      [LIVE_CHAT_CONSTANTS.UPDATE_BASKET_ZONE]: handleUpdateBasketZone,
      [LIVE_CHAT_CONSTANTS.UPDATE_CURRENT_TIMESTAMP]: handleCurrentStamp,
    }), [handleUpdateGameTimerStatus, handleChangeGameTimer, handleChangeGameSession, handleUpdateBasketZone, handleCurrentStamp]),
  );

  return (
    <div className={`w-full flex items-end gap-0 screen-500:gap-[10px] ${gameDetails?.isGameEnded ? "justify-center" : "justify-between"}`}>
      <TeamScores />
      {/* {!gameDetails?.isGameEnded && (<GameTimer />)} */}
      {/* <GameTimer /> */}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
    updateGameDetailsReducer: (data) => dispatch(updateGameDetailsReducer(data))
});

export default connect(null, mapDispatchToProps)(GameScoreAndTimer);
